/* eslint-disable */
import React, { ReactNode, useContext, useMemo } from 'react';
import { useStore, useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

type ContainerProps = {
  children: ReactNode
}

type SearchSkipParams = {
  skip: boolean;
  queryName: string;
  attributes: any;
}

type SearchOptsParams = {
  options: any;
  queryName: string;
}

type experienceContextParams = {
  customer: any;
  store: string;
}

export const SearchPageContainer = ({ children }: ContainerProps) => {
  const isBuyitagainEnabled = useConfigService('fs-prop:isBuyitagainEnabled');
  const isDiscoveryZonesSearchEnabled = useConfigService('fs-prop:isDiscoveryZonesSearchEnabled');

  const store = useStore();
  const { isCustomerIdentified = false } = useThdCustomer() || {};
  const { membershipInformation, storeId } = store;
  const experienceContext = useContext(ExperienceContext) as experienceContextParams;
  const { customer } = experienceContext;
  const isB2BCustomer = customer?.type === 'b2b';
  const ONLINE_STORE_ID = '8119';
  const loyaltyMembershipData = customer?.membershipInformation;

  const searchSkipFn = ({ skip, queryName, attributes }: SearchSkipParams): boolean => {
    if (queryName === 'searchStreamProduct' && !isB2BCustomer) {
      if (!attributes?.searchModel?.products?._children?.fulfillment) return true;
    }
    return skip;
  };

  const searchOptsFn = ({ options, queryName }: SearchOptsParams) => {
    if (queryName === 'searchStreamProduct' && !isB2BCustomer) {
      options.variables = undefined;
    }

    if (queryName === 'searchModel') {
      options.context = {
        ...(options.context || {}),
        timeout: 3000
      };
    }

    return options;
  };

  const isMounted = ({ mounted }: { mounted: boolean }) => {
      if (storeId === ONLINE_STORE_ID && mounted) {
          return false;
      }
      return mounted;
  };


  const defaultVariables = {
    skipInstallServices: false,
    skipSpecificationGroup: false,
    isBrandPricingPolicyCompliant: isCustomerIdentified,
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership,
    skipBuyitagain: !isBuyitagainEnabled,
    skipDiscoveryZones: !isDiscoveryZonesSearchEnabled,
  };

  const b2bDefaultVariables = useMemo(() => ({
      skipInstallServices: false,
      skipSpecificationGroup: false,
      loyaltyMembershipInput: loyaltyMembershipData,
      skipFavoriteCount: true,
      skipDiscoveryZones: !isDiscoveryZonesSearchEnabled,
      skipBuyitagain: !isBuyitagainEnabled,
      isBrandPricingPolicyCompliant: true
  }), [loyaltyMembershipData, isDiscoveryZonesSearchEnabled, isBuyitagainEnabled]);


  return (
    <QueryProvider
      cacheKey="page"
      defaultVariables={isB2BCustomer ? b2bDefaultVariables : defaultVariables}
      fusion
      skip={searchSkipFn}
      queryOptions={searchOptsFn}
      mounted={isMounted}
      forceClientQueriesOnServer={['searchModel', 'product']}
    >
      {children}
    </QueryProvider>
  );
};

SearchPageContainer.displayName = 'SearchPageContainer';